var React = require('react');

function Link (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.53337 1.86719H8.6667V3.46719H6.13337V9.86719H12.5334V7.33385H14.1334V11.4672H4.53337V1.86719Z","fill":"@color","key":0}),React.createElement("path",{"d":"M11.402 3.46719H10V1.86719H14.1334V6.00052H12.5334V4.5986L8.5657 8.56627L7.43433 7.4349L11.402 3.46719Z","fill":"@color","key":1}),React.createElement("path",{"d":"M3.4667 5.33385H1.8667V14.1339H10.6667V12.5339H3.4667V5.33385Z","fill":"@color","key":2})]);
}

Link.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","fill":"none"};

module.exports = Link;

Link.default = Link;
